module.exports = __webpack_public_path__ + "static/media/Partner-LogosBCA-PRIORITAS.39893658.png";